import React from 'react';
import { T } from '../customer/customers.theme';
import { EditIcon, TrashIcon } from '../customer/CustomersUI';
import { PrinterIcon } from '../menu/MenuUI';
import { printerIdOf, printerNameOf } from '../menu/menuApi';

/**
 * The category list.
 *
 * The phone's tile: the name, and under it the printer this category's tickets
 * come out of — `No ticket` when it has none, which is the phone's own wording
 * and the more useful half of the fact. A category with no printer still works;
 * its items just never reach the kitchen on paper.
 */

function RowAction({ label, tone, onClick, children }) {
  const [hovered, setHovered] = React.useState(false);
  const danger = tone === 'danger';

  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 30,
        height: 30,
        background: hovered ? (danger ? T.dangerTint : T.hover) : 'transparent',
        border: 'none',
        borderRadius: T.radiusControl,
        color: hovered ? (danger ? T.danger : T.ink) : T.inkGhost,
        cursor: 'pointer',
      }}
    >
      {children}
    </button>
  );
}

export default function CategoryList({ categories, printers, itemCounts, onEdit, onDelete }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {categories.map((category) => {
        const hasPrinter = Boolean(printerIdOf(category));
        const printer = printerNameOf(category, printers);
        const count = itemCounts[category._id] || 0;

        return (
          <div
            key={category._id}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              padding: '13px 18px',
              background: T.surface,
              border: `1px solid ${T.border}`,
              borderRadius: T.radiusPanel,
            }}
          >
            <div
              style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 4 }}
            >
              <span
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: T.ink,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {category.name}
              </span>

              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  fontSize: 12,
                  color: hasPrinter ? T.inkSoft : T.inkFaint,
                }}
              >
                <PrinterIcon />
                <span>{hasPrinter ? printer || 'Printer set' : 'No ticket'}</span>
              </span>
            </div>

            <span style={{ fontSize: 12, color: T.inkFaint, whiteSpace: 'nowrap' }}>
              {count} {count === 1 ? 'item' : 'items'}
            </span>

            <span style={{ display: 'flex', gap: 2 }}>
              <RowAction label="Edit" onClick={() => onEdit(category)}>
                <EditIcon size={15} />
              </RowAction>
              <RowAction label="Delete" tone="danger" onClick={() => onDelete(category)}>
                <TrashIcon size={15} />
              </RowAction>
            </span>
          </div>
        );
      })}
    </div>
  );
}
